/**
 * Konwertuje adres URL obrazu na format WebP, jeśli pochodzi z CDN.
 * @param {string|boolean|null} rawSource - Adres URL obrazu lub wartość logiczna.
 * @param {string} [emmezetaPlaceholder='https://example.com/placeholder.jpg'] - Domyślny obraz zastępczy.
 * @returns {string} Adres URL obrazu w formacie WebP lub oryginalny URL, ewentualnie obraz zastępczy.
 */

import readConfig from '../utils/readClientConfiguration'; // jeśli te importy są dostępne
import productionConfiguration from '../config/default.json'
let cdnBaseUrl = '';
try {
  cdnBaseUrl = readConfig(productionConfiguration, 'cdn') || '';
} catch (error) {
  console.error('Error reading CDN configuration:', error);
  cdnBaseUrl = '';
}


export function getWebp(rawSource, emmezetaPlaceholder = 'https://s3.emmezeta.hr/falcon/emmezeta-placeholder.png') {
  if (!rawSource || rawSource === false || rawSource === 'false') {
    return emmezetaPlaceholder;
  }

  if (typeof rawSource === 'string') {
    const validImageExtensions = /\.(jpg|jpeg|png)$/i;

    if (
        cdnBaseUrl &&
        typeof cdnBaseUrl === 'string' &&
        rawSource.startsWith(cdnBaseUrl) &&
        validImageExtensions.test(rawSource) &&
        !rawSource.endsWith('.webp')
    ) {
      return `${rawSource}.webp`;
    }
    return rawSource;
  }

  return emmezetaPlaceholder;
}